import { render, staticRenderFns } from "./SoftSearchCarousel.vue?vue&type=template&id=a8239eae"
import script from "./SoftSearchCarousel.vue?vue&type=script&lang=js"
export * from "./SoftSearchCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports